import {UrlTree} from '@angular/router';

export function getLastSegment(urlTree: UrlTree) {
  const segments = urlTree.root.children['primary'].segments;
  const lastSegment = segments[segments.length - 1].path;
  return lastSegment;
}
